import CheckCircleIcon from '../../assets/icons/check-circle-icon.svg'
import CancelCircleIcon from '../../assets/icons/cancel-circle-icon.svg'
import WarningCircleIcon from '../../assets/icons/warning-circle-icon.svg'
import PendingCircleIcon from '../../assets/icons/pending-circle-icon.svg'
import ReturnedCircleIcon from '../../assets/icons/returned-circle-icon.svg'
import ChevronForwardIcon from '../../assets/icons/chevron-forward-icon.svg'
import ValidatedCircleIcon from '../../assets/icons/validated-circle-icon.svg'

export const ReportSquareContainer = ({
  icon,
  mainData,
  iconWidth,
  loaderWidth,
  showMainIcon,
  className,
  dataFullyLoaded,
  showSecondaryData,
  reportName,
  showCancelIcon,
  showCheckIcon,
  secondaryData,
  showPendingIcon,
  showWarningIcon,
  backgroundColor,
  showReturnedIcon,
  showValidatedIcon,
  detailsButtonText,
  showButtonGoDetails,
  handleOnClickFunction,
  showSlimNavigationButton,
  handleButtonGoDetailsAction
}: {
  icon?: string
  mainData: string
  iconWidth?: string
  className?: string
  loaderWidth?: number
  showMainIcon?: boolean
  showCancelIcon?: boolean
  showCheckIcon?: boolean
  showPendingIcon?: boolean
  showSecondaryData: boolean
  showReturnedIcon?: boolean
  dataFullyLoaded?: boolean
  showValidatedIcon?: boolean
  reportName: string
  showWarningIcon?: boolean
  secondaryData?: string
  backgroundColor?: string
  detailsButtonText?: string
  showButtonGoDetails?: boolean
  showSlimNavigationButton?: boolean
  handleOnClickFunction?: () => void
  handleButtonGoDetailsAction?: () => void
}) => {
  return (
    <div
      onClick={() => handleOnClickFunction?.()}
      className={className ? `report-square-container ${className}` : 'report-square-container'}
      style={handleOnClickFunction ? { cursor: 'pointer', backgroundColor, border: backgroundColor ? 'none' : '1px solid #E5E5E5' } : { backgroundColor, border: backgroundColor ? 'none' : '1px solid #E5E5E5' }}
    >
      <div className="report-top-data-container">
        {showMainIcon && (
          <div className="report-icon-container">
            <img
              src={icon}
              alt="report-icon"
              style={iconWidth ? { width: iconWidth } : {}}
            />
            {showCheckIcon && (
              <img
                src={CheckCircleIcon}
                alt="report-icon"
                className="icon"
              />
            )}
            {showCancelIcon && (
              <img
                src={CancelCircleIcon}
                alt="report-icon"
                className="icon"
              />
            )}
            {showWarningIcon && (
              <img
                src={WarningCircleIcon}
                alt="report-icon"
                className="icon"
              />
            )}
            {showPendingIcon && (
              <img
                alt="report-icon"
                className="icon"
                src={PendingCircleIcon}
                style={{ width: '24px', height: '24px' }}
              />
            )}
            {showValidatedIcon && (
              <img
                alt="report-icon"
                className="icon"
                src={ValidatedCircleIcon}
                style={{ width: '24px', height: '24px' }}
              />
            )}
            {showReturnedIcon && (
              <img
                alt="report-icon"
                className="icon"
                src={ReturnedCircleIcon}
                style={{ width: '24px', height: '24px' }}
              />
            )}
          </div>
        )}
        {typeof dataFullyLoaded === 'undefined' || (typeof dataFullyLoaded !== 'undefined' && dataFullyLoaded === true) ? (
          <div className="report-main-data-container">{mainData}</div>
        ) : (
          <div
            className="data-container-loader"
            style={{ padding: '12px', width: `${loaderWidth || 200}px` }}
          ></div>
        )}
        {showSlimNavigationButton ? (
          <div
            className="report-data-name-container"
            style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}
          >
            <div>{reportName}</div>
            <div
              onClick={handleButtonGoDetailsAction}
              style={{ display: 'flex', gap: '10px', alignItems: 'center', cursor: 'pointer' }}
            >
              <div style={{ fontWeight: '600', color: '#0E9384' }}>{reportName}</div>
              <img
                alt="chevron-forward-icon"
                className="icon"
                src={ChevronForwardIcon}
                style={{ width: '24px', height: '24px' }}
              />
            </div>
          </div>
        ) : (
          <div className="report-data-name-container">{reportName}</div>
        )}
      </div>
      {showSecondaryData && <div className="report-bottom-data-container">{secondaryData}</div>}
      {showButtonGoDetails && (
        <div
          onClick={handleButtonGoDetailsAction}
          className="report-bottom-data-container"
        >
          <div className="report-details-button-container">
            <div className="button-text">{detailsButtonText}</div>
          </div>
        </div>
      )}
    </div>
  )
}
